module.exports = __webpack_public_path__ + "media/images/flags/32/Jordan-36fa8a70396c1a9520c5cd3523a48d5a.png";